RivalIQ.module('channels.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Nag = Marionette.ItemView.extend({
        events: {
            'click a': 'onClicked'
        },
        template: function (data) {

            let templateSelector = null;

            if (data.populating) {

                if (data.discoverable) {
                    templateSelector = 'channelsPopulatingTemplate';
                } else {
                    templateSelector = 'channelsPopulatingPrivateTemplate';
                }
            } else if (data.expiring) {
                templateSelector = (data.multiOauthToken ? 'multiTokenChannelsExpiringTemplate' : 'channelsExpiringTemplate');
            } else if (data.additionalTokenRequest) {

                templateSelector = 'channelsAdditionalTokenRequestTemplate';
            }

            const template = _.template($(`#${templateSelector}`).html());

            return template(data);
        },
        onClicked: function (e) {
            const me = this;
            e.preventDefault();
            if (me.model.get('multiOauthToken')) {
                // open the multi token modal!
                me.openMultiTokenModal();
            }

            me.triggerMethod('update');
            return false;
        },
        openMultiTokenModal: function () {
            const me = this;

            const model = RivalIQ.data.channels.get(me.model.get('source'));
            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.MultiTokenConnectionModal({
                model: model
            }));
        },
        onUpdate: function () {

            // abstract
        }
    });

});
